import { render, staticRenderFns } from "./Mydrag.vue?vue&type=template&id=c518e3c6&scoped=true"
import script from "./Mydrag.vue?vue&type=script&lang=js"
export * from "./Mydrag.vue?vue&type=script&lang=js"
import style0 from "./Mydrag.vue?vue&type=style&index=0&id=c518e3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c518e3c6",
  null
  
)

export default component.exports